export default __webpack_public_path__ + "static/media/mobile-cross-menu.2d655b4a.svg";